export const TASK_FORM_YES_NO_OPTION_VALUE = {
  No: 'no',
  Yes: 'yes',
}

export const QA_NAME_YES_NO_MODAL = 'yesNo'
